// extracted by mini-css-extract-plugin
export default {"linha":"NomeComSelo_linha__ZjuTJ","expandir":"NomeComSelo_expandir__mqDm0","nome":"NomeComSelo_nome__uhC7E"};